/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ResponseHeader } from "./ResponseHeader";
import * as t from "io-ts";

/**
 * The mocked response that will be generated by Mocker if the rule condition are all verified.
 */

// required attributes
const MockResponseR = t.interface({
  headers: t.readonlyArray(ResponseHeader, "array of ResponseHeader"),

  injected_parameters: t.readonlyArray(t.string, "array of string"),

  status: t.Integer
});

// optional attributes
const MockResponseO = t.partial({
  body: t.string,

  id: t.string
});

export const MockResponse = t.intersection(
  [MockResponseR, MockResponseO],
  "MockResponse"
);

export type MockResponse = t.TypeOf<typeof MockResponse>;
